import { render, staticRenderFns } from "./ManagementPlanForm.vue?vue&type=template&id=ca0c5572&scoped=true"
import script from "./ManagementPlanForm.vue?vue&type=script&lang=js"
export * from "./ManagementPlanForm.vue?vue&type=script&lang=js"
import style0 from "./ManagementPlanForm.vue?vue&type=style&index=0&id=ca0c5572&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0c5572",
  null
  
)

export default component.exports